import type * as MT from '../motornet/types';

/** Il massimo consentito da `/platform/vehicles`. */
export const EXPORT_PAGE_SIZE = 200;

export interface ExportProgress {
	loaded: number;
	total: number;
}

/**
 * Scarica tutte le pagine della `request` corrente, cosi' l'export riflette
 * filtri, ordinamento e scope di ruolo della vista.
 */
export const fetchAllPages = async (
	getPage: (
		params: MT.PlatformVehiclesRequest
	) => Promise<MT.PlatformVehiclesResponse>,
	request: MT.PlatformVehiclesRequest | null,
	onProgress?: (progress: ExportProgress) => void
): Promise<MT.PlatformVehicleListItem[]> => {
	if (!request) return [];

	const firstPage = await getPage({
		...request,
		page: 1,
		pageSize: EXPORT_PAGE_SIZE,
	});

	const all = [...firstPage.items];
	const pageCount = Math.ceil(firstPage.total / EXPORT_PAGE_SIZE);
	onProgress?.({ loaded: all.length, total: firstPage.total });

	for (let page = 2; page <= pageCount; page += 1) {
		const next = await getPage({
			...request,
			page,
			pageSize: EXPORT_PAGE_SIZE,
		});

		if (!next.items.length) break;

		all.push(...next.items);
		onProgress?.({ loaded: all.length, total: firstPage.total });
	}

	return all;
};
